const RTL_LANGUAGES = new Set(['ar', 'fa', 'he', 'ur', 'ps', 'sd', 'yi']);

export function isRtlLocale(locale: string): boolean {
  return RTL_LANGUAGES.has(locale.split('-')[0]!.toLowerCase());
}

const FSI = '\u2068';
const PDI = '\u2069';

// Mirrors Intl::Bidi::CONTROLS (app/lib/intl/bidi.rb): the marks, the
// deprecated embeddings/overrides, and the isolates themselves.
const BIDI_CONTROLS = /[\u200e\u200f\u061c\u202a-\u202e\u2066-\u2069]/g;

// Wraps one interpolated value so it cannot reorder the sentence around it. Stripping first is
// not optional for a user-supplied value: a control left inside ends the isolate early and
// hands the reordering back to whatever the value carries.
export function isolateBidi(value: string): string {
  return `${FSI}${value.replace(BIDI_CONTROLS, '')}${PDI}`;
}
